import React from 'react'
import { Button, Input, Segmented, Space } from 'antd'
import { ApartmentOutlined, PlusOutlined, SearchOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { DimensionGridMode, DimensionSourceFilter } from './DimensionGrid'
import DimensionUndoButton from './DimensionUndoButton'

interface DimensionToolbarProps {
  isAdmin: boolean
  onToggleEditMode: () => void
  viewMode: DimensionGridMode
  onViewModeChange: (mode: DimensionGridMode) => void
  searchText: string
  onSearchTextChange: (value: string) => void
  sourceFilter: DimensionSourceFilter
  onSourceFilterChange: (value: DimensionSourceFilter) => void
  canEdit: boolean
  onAdd: () => void
}

const DimensionToolbar: React.FC<DimensionToolbarProps> = ({
  isAdmin,
  onToggleEditMode,
  viewMode,
  onViewModeChange,
  searchText,
  onSearchTextChange,
  sourceFilter,
  onSourceFilterChange,
  canEdit,
  onAdd
}) => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 4,
        marginBottom: 4
      }}
    >
      <Space wrap>
        <Segmented
          value={viewMode}
          onChange={value => onViewModeChange(value as DimensionGridMode)}
          options={[
            { label: t('dimensionsPage:viewTree'), value: 'tree', icon: <ApartmentOutlined /> },
            { label: t('dimensionsPage:viewList'), value: 'list', icon: <UnorderedListOutlined /> }
          ]}
        />
        <Input
          allowClear
          prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,0.35)' }} />}
          placeholder={t('dimensionsPage:searchPlaceholder')}
          value={searchText}
          onChange={e => onSearchTextChange(e.target.value)}
          style={{ width: 240 }}
        />
        {viewMode === 'list' && (
          <Segmented
            value={sourceFilter}
            onChange={value => onSourceFilterChange(value as DimensionSourceFilter)}
            options={[
              { label: t('dimensionsPage:filterAll'), value: 'all' },
              { label: t('dimensionsPage:filterOwn'), value: 'own' },
              { label: t('dimensionsPage:filterIntegration'), value: 'integration' }
            ]}
          />
        )}
      </Space>

      <Space wrap>
        <DimensionUndoButton canEdit={canEdit} />
        {canEdit && (
          <Button icon={<PlusOutlined />} type="primary" onClick={onAdd}>
            {t('global:add-new')}
          </Button>
        )}
        {isAdmin && !canEdit && (
          <Button type="primary" onClick={onToggleEditMode}>
            {t('global:edit')}
          </Button>
        )}
      </Space>
    </div>
  )
}

export default DimensionToolbar
